import type { JobStatus } from '@conversia/shared-types';
import { api } from './client';

/** Panel de tracking de campo (ADMIN). Prefijo: /api/tracking */

export interface TrackingJob {
  id: string;
  descripcion: string;
  estado: JobStatus;
  cliente: string | null;
  direccion: string | null;
  zona: string | null;
  arrivedLat: number | null;
  arrivedLng: number | null;
  targetLat: number | null;
  targetLng: number | null;
  geofenceRadiusM: number | null;
  distanceM: number | null;
  enZona: boolean | null;
}

/** Base más cercana al técnico: nombre, distancia y si está dentro del radio. */
export interface NearestCenter {
  nombre: string;
  distanciaKm: number;
  dentro: boolean;
}

export interface TrackingTechnician {
  id: string;
  nombre: string;
  fotoUrl: string | null;
  nivel: string | null;
  lastLat: number | null;
  lastLng: number | null;
  lastLocationAt: string | null;
  currentJob: TrackingJob | null;
  /** Centro de operación más cercano (null sin bases o sin ubicación). */
  nearestCenter: NearestCenter | null;
}

/** Estado semántico de un trabajo del día (color del pin en el mapa). */
export type JobDayStatus =
  | 'en_camino'
  | 'llego'
  | 'vencido'
  | 'completado'
  | 'no_completado'
  | 'cancelado';

/** Trabajo del DÍA para el mapa. `lat/lng` = llegada > objetivo > null. */
export interface TrackingDayJob {
  id: string;
  descripcion: string;
  estado: JobStatus;
  status: JobDayStatus;
  cliente: string | null;
  tecnico: string | null;
  /** Id del técnico asignado (une el trabajo con su técnico en el panel). */
  employeeId: string | null;
  direccion: string | null;
  zona: string | null;
  scheduledAt: string | null;
  slaDeadline: string | null;
  lat: number | null;
  lng: number | null;
  /** Ponche de llegada (ruta del día del técnico): dónde y cuándo llegó. */
  arrivedLat: number | null;
  arrivedLng: number | null;
  arrivedAt: string | null;
  /** Registro del técnico al cerrar (código/serie, inconvenientes) y motivo de no completado. */
  registroProducto: string | null;
  motivo: string | null;
}

/** Centro de operación (base) configurado en /installation. */
export interface TrackingCenter {
  nombre: string;
  lat: number;
  lng: number;
  radioKm: number;
}

export interface TrackingState {
  technicians: TrackingTechnician[];
  jobsToday: TrackingDayJob[];
  /** Bases configuradas (referencia en el mapa; puede venir vacío). */
  centers: TrackingCenter[];
}

export const getTracking = () => api.get<TrackingState>('/api/tracking');
